// src/components/forms/fields/NumberField.tsx
// Utworzony w Krok 3

import React from 'react';
import { TextField, Box, Typography } from '@mui/material';
import { FormSection } from '../../../types/forms';

interface NumberFieldProps {
  section: FormSection;
  value: number | string | undefined;
  onChange: (value: number | string) => void;
  error?: string;
}

export const NumberField: React.FC<NumberFieldProps> = ({ section, value, onChange, error }) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    onChange(newValue === '' ? '' : Number(newValue));
  };

  return (
    <Box sx={{ mb: 3 }}>
      <TextField
        fullWidth
        type="number"
        label={section.label}
        value={value || ''}
        onChange={handleChange}
        error={!!error}
        helperText={error || section.description}
        required={!!section.validation?.required}
        variant="outlined"
        size="medium"
      />
    </Box>
  );
};